// extracted by mini-css-extract-plugin
export default {"sidebarContent":"IssueSidebar-module__sidebarContent--II51T","copilotAssignmentButton":"IssueSidebar-module__copilotAssignmentButton--58hJ3"};